export default [{ label: "Proportional", value: "PROPORTIONAL" }, { label: "Non Proportional", value: "NONPROPORTIONAL" }] as const;